import type { NavigationItem } from '@clean-code/models';
import {
  FrontOfficeContractsPermissions,
  FrontOfficeLimitReportPermissions,
  FrontOfficeStatisticsPermissions,
  FrontOfficeTicketsPermissions,
} from '@clean-code/shared/frontoffice/util-permissions';
import {
  faCalculator,
  faChartLine,
  faCircle,
  faEuroSign,
  faFileAlt,
  faFileContract,
  faGraduationCap,
  faHome,
  faPlug,
  faTicket,
} from '@fortawesome/pro-solid-svg-icons';

export const navigationItems: NavigationItem[] = [
  { name: 'side-nav.START', link: 'start', icon: faHome },
  {
    name: 'side-nav.ENERGY_MARKET',
    link: 'market/energy-market',
    icons: [faChartLine, faCircle, faPlug],
  },
  {
    name: 'side-nav.FINANCIAL_MARKETS',
    link: 'market/market',
    icons: [faChartLine, faCircle, faEuroSign],
  },
  {
    name: 'side-nav.SPREADS',
    link: 'spreads',
    icon: faCalculator,
  },
  {
    name: 'contracts.TITLE_PLURAL',
    link: 'contracts',
    icon: faFileContract,
    permission: FrontOfficeContractsPermissions.sideNavPermission,
  },
  {
    name: 'limit-reports.TITLE_PLURAL',
    link: 'limit-report',
    icon: faFileAlt,
    permission: [
      FrontOfficeLimitReportPermissions.limitReportOtherViewer,
      FrontOfficeLimitReportPermissions.limitReportGasViewer,
      FrontOfficeLimitReportPermissions.limitReportPowerViewer,
    ],
  },
  {
    name: 'statistics.TITLE_PLURAL',
    link: 'statistics',
    icon: faFileAlt,
    permission: [FrontOfficeStatisticsPermissions.statisticsMenue],
  },
  { name: 'side-nav.WIKI', link: 'wiki', icon: faGraduationCap },
  {
    name: 'tickets.NAME',
    link: 'my-tickets',
    icon: faTicket,
    permission: FrontOfficeTicketsPermissions.myTicketsSideNavPermission,
  },
];
